export default __webpack_public_path__ + "static/media/splash.b1f0337f.png";